// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_1HWxf","hidden":"_2P5er","timeWrapper":"_3-VIP","time":"_3zwtT","duration":"TxrYB","liveMode":"skjxS","separator":"_1h6GN"};